import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Base extends Component {
  static propTypes = {
    className: PropTypes.string,
  }

  render() {
    const { className, children } = this.props;

    return (
      <div className={className}>
        {children}
      </div>
    );
  }
}
